const debtor = {
	index: {
		account: {
			description: "This section contains your account details that we have on record.",
			success: "Your account details have been successfully updated!",
			title: "Account Details",
		},
		address: {
			description: "This section contains your address information.",
			success: "Your address details have been successfully updated!",
			title: "Address Details",
		},
		title: "Personal",
	},
	notifications: {
		description: "This section contains all notifications",
		table: {
			received: "Received Notification",
			timestamp: "Received On",
		},
		title: "Notifications",
	},
	security: {
		modal_setup: {
			description: "Follow the steps below to add 2FA to your account.",
			step_1: {
				description: "Scan the QR code below with an authenticator app.",
				title: "Step 1",
			},
			step_2: {
				description: "Confirm the 2FA code located in the authenticator app",
				placeholder: "6-digit code",
				title: "Step 2",
			},
			success: "2FA has been successfully enabled on your account.",
			title: "Set Up 2FA",
		},
		modal_unset: {
			description: "Follow the steps below to disable 2FA for your account.",
			step_1: {
				description: "Confirm that you really want to disable 2FA by entering your password.",
				placeholder: "Your password",
				title: "Step 1",
			},
			step_2: {
				description: "Confirm the 2FA code located in the authenticator app",
				placeholder: "6-digit code",
				title: "Step 2",
			},
			success: "2FA has been successfully disabled on your account.",
			title: "Disable 2FA",
			warning:
				"Attention! By disabling 2FA, you make it easier for hackers to gain access to your account.",
		},
		section1: {
			apps: {
				description:
					"For 2FA, we use the universal OAuth. You may already have an app. Otherwise, you can use one of the ones below.",
				title: "Authenticator apps",
			},
			description:
				"Two-Factor Authentication (2FA) is an authentication method where you have to successfully complete two steps to gain access to something. On the right, you will find some apps that you can use for this purpose.",
			title: "What is 2FA?",
		},
		section2: {
			description:
				"We recommend our users to apply 2FA. Adding additional verification enhances the security of your account.",
			title: "Enable 2FA",
		},
		status: {
			active: {
				button: "Disable 2FA",
				description: "Your account is extra secured with 2FA (Two-Factor Authentication).",
				title: "2FA Enabled",
			},
			inactive: {
				button: "Enable 2FA",
				description: "Attention! You have not added 2FA (Two-Factor Authentication) yet.",
				title: "2FA Not Enabled",
			},
		},
	},
	ssh: {
		description: "Here you will find the SSH keys associated with your account.",
		dialog: {
			create: {
				description:
					"Add your new public SSH key here. It will be stored in your account and can be added to your VPS instances.",
				external_description:
					"Add your external public SSH key here. You can add 1 SSH key at a time in this field.",
				external_title: "Add External SSH Key",
				form: {
					description: {
						label: "Description",
						placeholder: "Give your SSH key a description.",
					},
					public_key: {
						label: "Public SSH Key",
						placeholder: "Enter your unique SSH key.",
					},
					type: {
						label: "Type",
						placeholder: "Give your SSH key a type",
					},
				},
				status: {
					success: "SSH key has been added!",
					unknown: "Currently, an SSH key cannot be added. Please try again later.",
				},
				title: "Add SSH Key",
			},
			delete: {
				description:
					"Do you want to delete the SSH key with the description <strong>{{description}}</strong>?",
				status: {
					success: "SSH key has been deleted!",
					unknown: "Currently, the SSH key cannot be deleted. Please try again later.",
				},
				title: "Delete SSH Key",
			},
			edit: {
				description: "Edit your added public SSH key here.",
				external_description: "Edit your added external public SSH key here.",
				external_title: "Edit External SSH Key",
				form: {
					description: {
						label: "Description",
						placeholder: "Give your SSH key a description.",
					},
					public_key: {
						label: "Public SSH Key",
						placeholder: "Enter your unique SSH key.",
					},
					type: {
						label: "Type",
						placeholder: "Give your SSH key a type",
					},
				},
				title: "Edit SSH Key",
			},
		},
		invalid:
			"The SSH key you have entered is not a valid public SSH key. Please check that the SSH key has been entered correctly.\n If you are certain that the public SSH key is correct, please contact support.",
		item: {
			description: "Description",
			description_missing: "No description in SSH key",
			ssh_key: "Public SSH Key",
			type: "Type",
		},
		title: "SSH Keys",
	},
	tabs: {
		connections: "Connected Apps",
		debtor_information: "Account details",
		log: "Activity Log",
		notifications: "Notifications",
		security: "Security (2FA)",
		ssh_keys: "SSH Keys",
		update_information: "Login Information",
	},
	update_login_info: {
		password: {
			description: "In this section, you can change your current password.",
			success: "Your password has been successfully updated!",
			title: "Change Password",
		},
		username: {
			description:
				"In this section, you can change your username. <br/><br/><i><strong>Please note:</strong> To change your username, you need to enter your current password.</i>",
			success: "Your username has been successfully updated!",
			title: "Change Username",
		},
	},
};

export default debtor;
